import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

const SuccessSubmitOnReview = () => {
  const handleOkay = () => {
    window.location.pathname = "/publishedAssessment";
  };

  return (
    <Dialog
      open
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 0,
          boxShadow: "0 24px 60px rgba(0,0,0,0.25)",
          overflow: "hidden",
        },
      }}
    >
      <DialogContent sx={{ p: "32px 24px 16px" }}>
        {/* Success icon */}
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            bgcolor: "#ECFDF5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 2,
          }}
        >
          <CheckCircleRoundedIcon sx={{ fontSize: 34, color: "#059669" }} />
        </Box>

        {/* Title */}
        <Typography
          sx={{
            fontSize: 17,
            fontWeight: 700,
            color: "#111827",
            textAlign: "center",
            lineHeight: 1.3,
            mb: 1,
          }}
        >
          Submitted Successfully
        </Typography>

        {/* Message */}
        <Typography
          sx={{
            fontSize: 13,
            color: "#6B7280",
            textAlign: "center",
            lineHeight: 1.55,
          }}
        >
          You have successfully submitted this assessment.
        </Typography>
      </DialogContent>

      <Stack sx={{ px: 3, pb: 3, pt: 1 }}>
        <Button
          onClick={handleOkay}
          variant="contained"
          fullWidth
          sx={{
            textTransform: "none",
            fontWeight: 600,
            fontSize: 13,
            borderRadius: 2,
            py: 1.1,
            bgcolor: "#059669",
            boxShadow: "0 3px 10px rgba(5,150,105,.25)",
            "&:hover": {
              bgcolor: "#047857",
              boxShadow: "0 5px 14px rgba(5,150,105,.35)",
            },
          }}
        >
          Okay
        </Button>
      </Stack>
    </Dialog>
  );
};

export default SuccessSubmitOnReview;
